import { render, staticRenderFns } from "./diagram.vue?vue&type=template&id=1c836f04&scoped=true"
import script from "./diagram.vue?vue&type=script&lang=js"
export * from "./diagram.vue?vue&type=script&lang=js"
import style0 from "./diagram.vue?vue&type=style&index=0&id=1c836f04&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c836f04",
  null
  
)

export default component.exports